import { API_BASE, apiHeaders, apiUrl } from "./api-base"

export const api = {
  baseUrl: API_BASE,
  async get<T = unknown>(path: string): Promise<T> {
    const res = await fetch(apiUrl(path), {
      credentials: "include",
      headers: apiHeaders(),
    })
    if (!res.ok) throw new Error(`GET ${path} → ${res.status}`)
    return (await res.json()) as T
  },
}

export interface ModuleRegistry {
  modules: ModuleEntry[]
}
export interface ModuleEntry {
  id: string
  name: string
  version: string
  description: string
  dashboards: DashboardEntry[]
  routes: { method: string; path: string; auth: string }[]
  webhooks: { path: string; signature: string }[]
}
export interface DashboardEntry {
  id: string
  title: string
  slug: string
  icon?: string
  default: boolean
  panels: PanelEntry[]
}
export interface PanelEntry {
  id: string
  title: string
  kind: string
  size?: string
  data?: { source: string; topics?: string[] }
}
